<script>
import CMSSinglePage from "@/views/components/cms/CMSSinglePage.vue";

export default {
  name: "Empfehlung",
  components: {CMSSinglePage},
}
</script>

<template>
 <CMSSinglePage list-element="EmpfehlungList"></CMSSinglePage>
</template>

<style scoped>

</style>
